import { Add20Regular } from '@fluentui/react-icons';
import React from 'react';
export function getEmptyStateAadMap(_a) {
    var actions = _a.actions, emptyStateResources = _a.emptyStateResources, darkMode = _a.darkMode, isDesktopApp = _a.isDesktopApp;
    var emptyStateMap = new Map([
        [
            'all',
            {
                zeroExperienceTitle: emptyStateResources.allEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.allEmptyStateSubtitle,
                imageName: darkMode ? 'all_dark' : 'all_light',
            },
        ],
        [
            'recent',
            {
                zeroExperienceTitle: emptyStateResources.allEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.allEmptyStateSubtitle,
                imageName: darkMode ? 'all_dark' : 'all_light',
            },
        ],
        [
            'shared',
            {
                zeroExperienceTitle: emptyStateResources.noSharedTitle,
                zeroExperienceSubtitle: emptyStateResources.noSharedSubtitle,
                imageName: darkMode ? 'shared_dark' : 'shared_light',
            },
        ],
        [
            'favorites',
            {
                zeroExperienceTitle: emptyStateResources.noFavoritesTitle,
                zeroExperienceSubtitle: emptyStateResources.noFavoritesSubtitle,
                imageName: 'favorites_light_and_dark',
            },
        ],
        [
            'drafts',
            {
                zeroExperienceTitle: emptyStateResources.noDraftsTitle,
                zeroExperienceSubtitle: emptyStateResources.noDraftsSubtitle,
                primaryActionButton: (actions === null || actions === void 0 ? void 0 : actions.onCreateNewDraft)
                    ? {
                        icon: React.createElement(Add20Regular, null),
                        onClick: actions.onCreateNewDraft,
                        text: emptyStateResources.newDraftButtonText,
                    }
                    : undefined,
            },
        ],
        [
            'people',
            {
                zeroExperienceTitle: emptyStateResources.noSharedTitle,
                zeroExperienceSubtitle: emptyStateResources.noSharedSubtitle,
                imageName: darkMode ? 'shared_dark' : 'shared_light',
            },
        ],
        [
            'meetings',
            {
                zeroExperienceTitle: emptyStateResources.meetingEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.meetingEmptyStateSubtitle,
                imageName: darkMode ? 'meetings_dark' : 'meetings_light',
            },
        ],
        [
            'cloudFiles',
            {
                zeroExperienceTitle: emptyStateResources.allEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.allEmptyStateSubtitle,
                imageName: darkMode ? 'onedrive_dark' : 'onedrive_light',
            },
        ],
        [
            'local',
            {
                zeroExperienceTitle: emptyStateResources.localEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.localEmptyStateSubtitle,
                imageName: 'local_light_and_dark',
            },
        ],
        [
            'attachments',
            {
                zeroExperienceTitle: emptyStateResources.attachmentsEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.attachmentsEmptyStateSubtitle,
                imageName: darkMode ? 'attachments_dark' : 'attachments_light',
            },
        ],
        [
            'filter',
            {
                zeroExperienceSubtitle: emptyStateResources.noFilterResultsSubtitle,
                imageName: darkMode ? 'search_dark' : 'search_light',
            },
        ],
        [
            'emptyTag',
            {
                zeroExperienceTitle: emptyStateResources.tagEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.tagEmptyStateSubtitle,
                imageName: darkMode ? 'tag_dark' : 'tag_light',
            },
        ],
        [
            'error',
            {
                zeroExperienceTitle: emptyStateResources.errorStateTitle,
                zeroExperienceSubtitle: isDesktopApp
                    ? emptyStateResources.errorStateSubtitleDesktop
                    : emptyStateResources.errorStateSubtitle,
                imageName: darkMode ? 'error_dark' : 'error_light',
            },
        ],
        [
            'createdByMe',
            {
                zeroExperienceTitle: emptyStateResources.createdByMeEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.createdByMeEmptyStateSubtitle,
                imageName: darkMode ? 'all_dark' : 'all_light',
            },
        ],
        [
            'meetingRecordings',
            {
                zeroExperienceTitle: emptyStateResources.meetingRecordingEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.meetingRecordingEmptyStateSubtitle,
                imageName: darkMode ? 'meetings_dark' : 'meetings_light',
            },
        ],
        [
            'playlists',
            {
                zeroExperienceTitle: emptyStateResources.playlistEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.playlistEmptyStateSubtitle,
                imageName: darkMode ? 'empty_state_dark' : 'empty_state_light',
            },
        ],
    ]);
    return emptyStateMap;
}
//# sourceMappingURL=getEmptyStateAadMap.js.map